import axios from "../utils/axios";
import toast from "react-hot-toast";
import { HOST_API_URL } from "../../config";
import { APIResponse } from "../types";
import { Method } from "axios";
import { getSession } from "../auth/utils";
import { useNavigate } from "react-router-dom";
import routes from "@/routers/routes";

interface ApiRequestOptions {
    headers?: object;
    params?: object;
    data?: object;
    showLoading?: boolean;
    navigate?: ReturnType<typeof useNavigate>;
}

async function apiRequest<T>(
    method: Method,
    endpoint: string,
    options: ApiRequestOptions = {},
): Promise<APIResponse<T>> {
    const { headers = {}, params, data, showLoading, navigate } = options;
    let loadingToastId: React.ReactText | null = null;

    const token = getSession();
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    if (showLoading) {
        loadingToastId = toast.loading("Loading...");
    }

    try {
        const response = await axios({
            method,
            url: `${HOST_API_URL}${endpoint}`,
            headers,
            params,
            data,
        });

        if (showLoading && loadingToastId) {
            toast.dismiss(loadingToastId);
        }

        if (method === "POST" || method === "PUT" || method === "DELETE") {
            toast.success(response.data.message);
        }

        return {
            statusCode: response.status,
            message: response.statusText,
            data: response.data.data as T,
        };
    } catch (error: any) {
        if (showLoading && loadingToastId) {
            toast.dismiss(loadingToastId);
        }
        console.error("API Request Error:", error);

        if (error.response?.status === 403 && navigate) {
            navigate(routes.accessDenied);
        }

        const errorMessage =
            error?.message ??
            "An error occurred while processing your request.";
        toast.error(errorMessage);
        throw {
            statusCode: error.response?.status || 500,
            message: errorMessage,
            data: error.response?.data.data as T,
        };
    }
}

export { apiRequest };
